import { z } from 'zod'

/**
 * An advertising platform a company can connect. Mirrors `AdPlatform` in the
 * Prisma schema. Google Ads only for now; Meta and TikTok follow in specs of
 * their own (docs/ad-analytics.spec.md).
 */
export const AD_PLATFORMS = ['google_ads'] as const

export const adPlatformSchema = z.enum(AD_PLATFORMS)

export type AdPlatform = z.infer<typeof adPlatformSchema>
